// Plain-language diagnostics generated by the backend engine.

import React from 'react';

import type { Insight } from '../types';

interface Props {
    insights: Insight[];
}

const STYLES: Record<Insight['severity'], { box: string; icon: string }> = {
    warning: { box: 'border-l-amber-400 bg-amber-50/60', icon: 'bx-error text-amber-500' },
    positive: { box: 'border-l-emerald-500 bg-emerald-50/60', icon: 'bx-check-shield text-emerald-600' },
    info: { box: 'border-l-sky-500 bg-sky-50/60', icon: 'bx-info-circle text-sky-600' },
};

export const InsightsPanel: React.FC<Props> = ({ insights }) => {
    if (insights.length === 0) return null;
    return (
        <div className="bg-white p-5 rounded-2xl shadow-sm border border-slate-100">
            <h3 className="text-lg font-bold text-slate-800 mb-4">Diagnostic Findings</h3>
            <ul className="space-y-3">
                {insights.map((insight, i) => {
                    const style = STYLES[insight.severity] ?? STYLES.info;
                    return (
                        <li
                            key={`${insight.title}-${i}`}
                            className={`flex gap-3 p-3 rounded-xl border border-slate-100 border-l-4 ${style.box}`}
                        >
                            <i className={`bx ${style.icon} text-xl mt-0.5`} aria-hidden="true"></i>
                            <div>
                                <p className="text-sm font-bold text-slate-800">{insight.title}</p>
                                <p className="text-sm text-slate-600 mt-0.5">{insight.message}</p>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
